"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var clsx_1 = __importDefault(require("clsx"));
var Polished_1 = require("../utils/Polished");
var reactHelpers_1 = require("../utils/helpers/reactHelpers");
var PopupActionsSC = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: ", ";\n\n  > * {\n    margin: 0 ", " 0 0;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"], ["\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: ", ";\n\n  > * {\n    margin: 0 ", " 0 0;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"])), Polished_1.rem('12px'), Polished_1.rem('12px'));
var PopupActions = function (props) {
    var children = props.children, forwardedRef = props.forwardedRef, classNameProp = props.className, others = __rest(props, ["children", "forwardedRef", "className"]);
    return children ? (react_1.default.createElement(PopupActionsSC, __assign({ ref: forwardedRef, className: clsx_1.default(classNameProp) }, others), children)) : null;
};
PopupActions.propTypes = {
    children: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    forwardedRef: prop_types_1.default.any,
    className: prop_types_1.default.string
};
PopupActions.defaultProps = {
    children: null,
    forwardedRef: react_1.default.createRef(),
    className: undefined
};
exports.default = reactHelpers_1.withForwardedRef(PopupActions);
var templateObject_1;
//# sourceMappingURL=PopupActions.js.map